import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { fetchHasCmCampaigns } from '../api'
import { reportsKeys } from '../queryKeys/reportsKeys'

const useHasCmCampaignsQuery = (enabled = false) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const { data, isLoading, isError } = useQuery({
    queryKey: reportsKeys.hasCmCampaigns(accountId ?? ''),
    queryFn: () => fetchHasCmCampaigns(accountId!),
    enabled: !!accountId && enabled,
    staleTime: 5 * 60 * 1000,
  })

  useEffect(() => {
    if (isError) {
      errorToast('Failed to load contextual data. Please try again.')
    }
  }, [isError])

  return { hasCmCampaigns: data ?? false, isLoading }
}

export default useHasCmCampaignsQuery
